import { useMutation } from "@tanstack/react-query";
import { getAuditVideoPlaybackUrl } from "services/auditService";

export function useAuditVideo() {
    return useMutation({
        mutationFn: (auditId: string) => getAuditVideoPlaybackUrl(auditId),
    });
}
